export default __webpack_public_path__ + "static/poster-1a64611353266efe9b89b86da298e9f9.png";